import { configureStore } from '@reduxjs/toolkit';
import BranchCodeSlice from './slices/branchCodeSlice';
import CategorySlice from './slices/categorySlice';
import ConstantDropdownSlice from './slices/constantDropdown';
import CostCenterSlice from './slices/costCenterSlice';
import dailyAttendanceSlice from './slices/dailyAttendanceSlice';
import DepartmentSlice from './slices/departmentSlice';
import JobGradeSlice from './slices/jobGradeSlice';
import PayPeriodSlice from './slices/payPeriodSlice';
import PayPointSlice from './slices/payPointSlice';
import payrollSettingWizardSlice from './slices/payrollSettingWizardSlice';
import profileSlice from './slices/profileSlice';
import currencySlice from './slices/usdCurrencyToggleSlice';
import userCheckSlice from './slices/userCheckSlice';
import ocrTimeLogsSlice from './slices/OcrTimeLogsSlice';
import monthlySummarySlice from './slices/monthlySummary';

const store = configureStore({
	reducer: {
		userProfile: profileSlice.reducer,
		userCheck: userCheckSlice.reducer,
		departments: DepartmentSlice.reducer,
		categories: CategorySlice.reducer,
		branches: BranchCodeSlice.reducer,
		costCenters: CostCenterSlice.reducer,
		jobGrades: JobGradeSlice.reducer,
		payPoints: PayPointSlice.reducer,
		constantDropdown: ConstantDropdownSlice.reducer,
		payrollSettingWizard: payrollSettingWizardSlice.reducer,
		payPeriod: PayPeriodSlice.reducer,
		usdCurrencyToggle: currencySlice.reducer,
		dailyAttendance: dailyAttendanceSlice.reducer,
		monthlySummary: monthlySummarySlice.reducer,
		ocrTimeLogs: ocrTimeLogsSlice.reducer,
	},
});

export default store;
export type AppDispatch = typeof store.dispatch;
